import ApiService from '@/services/api.service'

const CompanyService = {
  getCompanyBySlug: async function (slug) {
    return await ApiService.get(`/company/${slug}`).then(res => {
      return res
    })
  },
  getCompanyJobs: async function (slug) {
    return await ApiService.get(`/company/jobs/${slug}`).then(res => {
      return res
    })
  },
  getRelatedCompanies: async function (slug) {
    return await ApiService.get(`/company/related-company/${slug}`).then(res => {
      return res
    })
  },
  getAllCompanies: async function () {
    return await ApiService.get('/company/fetch/all').then(res => {
      return res
    })
  },
}

export default CompanyService
